import React from 'react';
import ReactDom from 'react-dom';
import Modal from '../Modal';

import './index.scss';

enum MODAL_TYPE {
  CONFIRM = 'confirm',
  ALERT = 'alert',
}

export default function CustomModalDialog(props) {
  const {
    type = MODAL_TYPE.CONFIRM, // alert/confirm
    className,
    showModal,
    onHide,
    cancelText = '取消',
    confirmText = '确认',
    onConfirm = () => {},
    onCancel = () => {},
    children,
  } = props;
  return ReactDom.createPortal(
    <Modal
      className={`custom-modal-dialog ${className}`}
      isOpened={showModal}
      onHide={onHide}
      closeIcon={false}
      closeOnClickOverlay
      useAnimate={false}
    >
      <div className="c-modal-wrapper">
        <div className="c-modal-content">
          {children}
        </div>
        <div className="c-action-field">
          {
            type === MODAL_TYPE.CONFIRM && (
              <React.Fragment>
                <div className="action-btn cancel-btn" onClick={() => onCancel()}>{cancelText}</div>
                <div className="action-btn confirm-btn" onClick={() => { onConfirm(); }}>{confirmText}</div>
              </React.Fragment>
            )
          }
          {
            type === MODAL_TYPE.ALERT && (
              <React.Fragment>
                <div className="action-btn confirm-btn" onClick={() => { onConfirm(); }}>{confirmText}</div>
              </React.Fragment>
            )
          }
        </div>
      </div>
    </Modal>,
    document.body,
  );
}
